import CampaignKeyWordTable from '~/modules/retailMedia/components/_tables/CampaignKeyWordTable'
import ReviewCampaignCategories from '~/modules/retailMedia/components/ReviewCampaignCategories'

const ReviewCampaignTargeting = ({ data }: { data: CampaignView }) => {
  const showKeywords = !!data.keywords?.length
  const categories = data.raw?.categories ?? []

  if (showKeywords) {
    return (
      <div data-testid="review-campaign-keywords">
        <CampaignKeyWordTable campaignId={data.id} panelTemplate="shoreline" />
      </div>
    )
  }

  if (categories.length) {
    return (
      <div data-testid="review-campaign-categories">
        <ReviewCampaignCategories categories={categories} />
      </div>
    )
  }

  return null
}

export default ReviewCampaignTargeting
